export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20warm%20minimalist%20product%20photography%20panorama%20of%20fashion%20items%20sneakers%20hoodies%20bags%20and%20accessories%20on%20light%20cream%20surface%20with%20gentle%20natural%20daylight%20airy%20atmosphere%20clean%20european%20aesthetic%20high%20detail%20soft%20shadows%20warm%20neutral%20palette%20horizontal%20composition&width=1600&height=600&seq=cta-bg-gtbuy&orientation=landscape"
          alt="GTBuy product panorama"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-black/30"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl text-white font-light leading-none tracking-tight lowercase">
            stop overpaying
            <br />
            online
          </h2>

          <div className="lg:text-right">
            <p className="text-white/70 text-sm md:text-base leading-relaxed max-w-xs lg:ml-auto">
              Compare 5000+ products
              <br />
              across all major platforms
            </p>
          </div>
        </div>

        <div className="mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 bg-white text-foreground-900 px-6 py-3.5 rounded-full text-sm font-semibold hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            <span>gtbuy sheet</span>
            <span className="flex items-center justify-center w-7 h-7 bg-foreground-900 text-white rounded-full">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}